import { FC } from 'react';
import React from 'react';

import { TextField } from '@gem/ui-kit';

import { useDateFieldPresenter } from './DateField.presenter';
import styles from './DateField.styles.m.css';

interface IDateFieldProps {
  value: Date;
  hasError: boolean;
  message: string;
  onChange(date: Date): void;
  minDate?: Date;
}

export const DateField: FC<IDateFieldProps> = React.forwardRef<HTMLInputElement, IDateFieldProps>(
  (props, ref) => {
    const { value, onChange, minDate, ...rest } = props;

    const presenter = useDateFieldPresenter({
      value,
      onChange,
      minDate,
    });

    return (
      <TextField
        {...rest}
        ref={ref}
        onChange={presenter.onChangeInput}
        onFocus={presenter.onFocus}
        value={presenter.inputValue}
        className={styles.container}
      />
    );
  }
);
